export default {
  fields: {
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    },
  },
  relationships: {
    photos: {
      type: 'photos'
    },
    photo: {
      type: 'photos'
    },
    cities: {
      type: 'cities'
    }
  }
}
